export default {
  jumpTo: {
    id: 'article_table_of_content_jump_to',
    defaultMessage: 'Table of contents',
  },
} as const
